import { RiskPolicyChallengeAcknowledgeContent } from "@/components/access/RiskPolicyChallengeAcknowledgeContent";

export default function RiskPolicyChallengeAcknowledge(): JSX.Element {
  return <RiskPolicyChallengeAcknowledgeContent />;
}
